<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-glasses" style="font-size: 40px"></i>
                <h2>Leituras</h2>
              </div>
            </div>
          </div>
          <form action="" @submit.stop.prevent="gerarPlanilha">
            <div class="row">
              <div class="sm-12">
                <select v-model="operacao">
                  <option value="Consultar Leituras">Consultar Leituras</option>
                  <option value="Lançar Leituras">Lançar Leituras</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="sm-6">
                <select v-model="tipo">
                  <option value="A">Água</option>
                  <option value="G">Gás</option>
                </select>
              </div>
              <div class="sm-6">
                <input
                  type="date"
                  lang="pt"
                  v-model="data"
                  v-if="operacao == 'Lançar Leituras'"
                  placeholder="Data Leitura" />
              </div>
            </div>
            <div class="row">
              <div class="sm-6">
                <input type="number" placeholder="Ano" v-model="ano" />
              </div>
              <div class="sm-6">
                <select v-model="mes">
                  <option value="01">Janeiro</option>
                  <option value="02">Fevereiro</option>
                  <option value="03">Março</option>
                  <option value="04">Abril</option>
                  <option value="05">Maio</option>
                  <option value="06">Junho</option>
                  <option value="07">Julho</option>
                  <option value="08">Agosto</option>
                  <option value="09">Setembro</option>
                  <option value="10">Outubro</option>
                  <option value="11">Novembro</option>
                  <option value="12">Dezembro</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="sm-12">
                <button class="button secondary">Gerar planilha</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DateTime } from "luxon";

export default {
  data() {
    let hoje = DateTime.local().toFormat("yyyy-LL-dd");
    let mes = DateTime.local().toFormat("LL");
    let ano = DateTime.local().toFormat("yyyy");
    return {
      operacao: "Consultar Leituras",
      mes,
      ano,
      tipo: "A",
      data: hoje,
    };
  },
  methods: {
    gerarPlanilha() {
      this.$router.push({
        path: "/financeiro/leituras/planilha",
        query: {
          operacao: this.operacao,
          mes: this.mes,
          ano: this.ano,
          tipo: this.tipo,
          data: this.data,
        },
      });
    },
  },
};
</script>
